import { useEffect, useState } from 'react'
import Proxies from 'Components/proxies'
import React from 'react'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Form, Row, Col, Input } from 'reactstrap'
import { toast } from 'react-toastify'

export default function ScheduledJobsForm(props) {
  const [loading, setLoading] = useState(false)
  const { ScheduledJobID } = props.match.params
  const [scheduledJob, setScheduledJob] = useState({})

  const getScheduledJob = async () => {
    setLoading(true)
    const responseJSON = await Proxies.GET('scheduledJobs/fetch', { ScheduledJobID })
    if (responseJSON.error) {
      // console.log(responseJSON.error)
    } else {
      responseJSON.payload = JSON.stringify(responseJSON.payload)
      setScheduledJob(responseJSON)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (ScheduledJobID) {
      getScheduledJob()
    }
  }, [])

  function resetData() {
    if (ScheduledJobID) {
      getScheduledJob()
    } else {
      setScheduledJob({})
    }
  }

  function saveScheduledJob() {
    Proxies.POST('scheduledJobs/replace', scheduledJob).then(responseJSON => {
      if (responseJSON.error) {
        toast.error('Error while saving scheduledJob', {
          autoClose: 5000
        })
      } else {
        toast.success(ScheduledJobID ? 'Successfully Updated' : 'Successfully Created', {
          autoClose: 5000
        })
        window.location('/scheduledJobs')
      }
    })
  }

  return (
    <CollapsibleCard startOpen={true} header={<strong>ScheduledJob</strong>}>
      <Form>
        <Row className='mb-3'>
          <Col xs='2'>
            <label>Description</label>
          </Col>
          <Col xs='10'>
            <Input
              type='text'
              value={scheduledJob.description}
              name='description'
              id='description'
              onChange={e => setScheduledJob({ ...scheduledJob, description: e.target.value })}
            />
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col xs='2'>
            <label>Cron string*</label>
          </Col>
          <Col xs='10'>
            <Input
              type='text'
              value={scheduledJob.cronString}
              name='cronString'
              id='cronString'
              onChange={e => setScheduledJob({ ...scheduledJob, cronString: e.target.value })}
            />
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col xs='2'>
            <label>Endpoint*</label>
          </Col>
          <Col xs='10'>
            <Input
              type='text'
              value={scheduledJob.endpoint}
              name='endpoint'
              id='endpoint'
              onChange={e => setScheduledJob({ ...scheduledJob, endpoint: e.target.value })}
            />
          </Col>
        </Row>
        <Row className='mb-3'>
          <Col xs='2'>
            <label>Payload</label>
          </Col>
          <Col xs='10'>
            <Input
              type='textarea'
              value={scheduledJob.payload}
              name='payload'
              id='payload'
              onChange={e => setScheduledJob({ ...scheduledJob, payload: e.target.value })}
            />
          </Col>
        </Row>
        <Button onClick={saveScheduledJob} disabled={loading}>
          {loading ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
        </Button>
        <Button scheduledJob='danger' onClick={resetData} className='ml-2'>
          Nulstil
        </Button>
      </Form>
    </CollapsibleCard>
  )
}
